//lib
import { formatAddedSocialProfile } from '@/lib/socialProfile';

//Components
import ItemWrapper from '@/components/pages/reports/components/Items/ItemWrapper';

// Types
import type { SocialProfilesAndGroupsCondensedListProps } from '@/components/composite/SocialProfiles/SocialProfilesAndGroupsCondensedList';
import type { SocialProfileType } from '@/types/socialProfileType';

type SocialProfileItemProps = {
    item: SocialProfileType;
    size?: SocialProfilesAndGroupsCondensedListProps['size'];
    className?: string;
};

const SocialProfileItem = ({ item, size = 'sm', className }: SocialProfileItemProps) => {
    return (
        <ItemWrapper
            spList={[item]}
            mainContent={formatAddedSocialProfile(item).main_name}
            subContent={formatAddedSocialProfile(item).sub_name}
            size={size}
            className={className}
        />
    );
};

export default SocialProfileItem;
